const deleteModalContentStyle = {
  textAlign: "left",
  border: "none",
  borderRadius: "8px",
  boxShadow: "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  width: "500px",
  padding: "15px",
  background: "var(--sl-bg-primary)",
  color: "var(--sl-text-primary)",
};

export default deleteModalContentStyle;
